import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    ownerType: "",
    ownerAmount: "",
    ownerSource: "",
    ownersNumber: 1,
    page: 1
};

const vehicleSlice = createSlice({
    name: "vehicle",
    initialState,
    reducers: {
        setOwnerType: (state, action) => {
            state.ownerType = action.payload;
        },
        setOwnerAmount: (state, action) => {
            state.ownerAmount = action.payload;
        },
        setOwnerSource: (state, action) => {
            state.ownerSource = action.payload;
        },
        setOwnersNumber: (state, action) => {
            state.ownersNumber = action.payload;
        },
        setPage: (state,action) => {
            state.page = action.payload;
          },
    },
});

export const { setOwnerType, setOwnerAmount, setOwnerSource, setOwnersNumber,setPage} = vehicleSlice.actions;
export default vehicleSlice.reducer;